<template>
  <div class='app-container'>
    <icare-table
      ref='table'
      searchTip='请根据设备编号进行搜索'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='paginationConfig'
      methods-data='get_payment_order'
      params>
      <div>
        <span class='left-table'>用户手机：</span>
        <el-input v-model='paginationConfig.phone' placeholder='请输入手机号码' style='width: 200px;' clearable></el-input>
        <span class='left-table'>订单号：</span>
        <el-input v-model='paginationConfig.order_id' placeholder='请输入订单号' style='width: 200px;' clearable></el-input>
        <span class='left-table'>插座编号：</span>
        <el-input v-model='paginationConfig.code' placeholder='请输入插座编号' style='width: 200px;' clearable></el-input>
        <span class='left-table'>
          状态：
          <el-select v-model='payment_status' placeholder='请选择' @change='statusSelect'>
            <el-option
              v-for='item in statusList'
              :key='item.value'
              :label='item.label'
              :value='item.value'
            ></el-option>
          </el-select>
        </span>
        <span class='left-table'>创建时间：</span>
        <el-date-picker
          v-model='findDateTime'
          type='datetimerange'
          align='right'
          start-placeholder='开始'
          end-placeholder='结止'
          format='yyyy-MM-dd HH:mm:ss'
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
        <span class='left-table'>
          <el-button type='primary' icon='el-icon-search' @click='find'>查找</el-button>
        </span>
      </div>
    </icare-table>
  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'
import { formatGap } from '../../utils'

export default {
  name: 'get_payment_order',
  data() {
    return {
      paginationConfig: {
        device_type: 1,
        order_id: '',
        start_time: '',
        end_time: '',
        payment_status: '',
        phone: '',
        code: ''
      },
      findDateTime: [],
      statusList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'WAIT',
          label: '待支付'
        },
        {
          value: 'FINISH',
          label: '已支付'
        },
        {
          value: 'REFUND',
          label: '已退款'
        },
        {
          value: 'APPLY_REFUND',
          label: '申请退款'
        },
        {
          value: 'CLOSE',
          label: '已关闭'
        }
      ],
      order_id: '',
      payment_status: '',
      titleConfig: [
        {
          field: 'id',
          title: '订单号',
          visible: true
        },
        {
          field: 'platform_trade_code',
          title: '交易单号',
          visible: false
        },
        {
          field: 'cabinet_id',
          title: '机柜编号',
          visible: true,
          fuc: function(title, item, row) {
            return row.cabinet_id
          }
        },
        {
          field: 'code',
          title: '插座编号',
          visible: true
        },
        {
          field: 'user_phone',
          title: '用户手机',
          visible: true
        },
        {
          field: 'total',
          title: '应付金额',
          visible: true,
          fuc: val => {
            return val == undefined ? '0.00 元' : (val / 100).toFixed(2) + ' 元'
          }
        },
        {
          field: 'cash',
          title: '实付金额',
          visible: true,
          fuc: function(title, item, row) {
            var str = row.coupon_id == '' ? '' : '(券后)'
            return row.cash == undefined ? '0.00 元' + str : (row.cash / 100).toFixed(2) + ' 元' + str
          }
        },
        {
          field: 'coupon_id',
          title: '优惠券编号',
          visible: false,
          fuc: val => {
            return val == undefined ? '' : val
          }
        },

        {
          field: 'payment_value',
          title: '购买时长',
          visible: true,
          fuc: function(title, item, row) {
            if (row.device_type == 1) {
              return row.payment_value == undefined ? '0 分钟' : (row.payment_value / 60) + ' 分钟'
            } else {
              return '-'
            }
          }
        },
        {
          field: 'payment_time',
          title: '开始时间',
          visible: true,
          fuc: function(title, item, row) {
            if (row.payment_time != undefined) {
              return row.payment_time
            }
            if (row.payment_time == undefined) {
              return row.create_time
            }

            return '-'
          }
        },
        {
          field: 'stop_time',
          title: '停止时间',
          visible: true
        },
        {
          field: 'stop_time',
          title: '充电时长',
          visible: true,
          fuc: function(title, item, row) {
            if (row.stop_time != undefined && row.payment_time != undefined) {
              return formatGap(row.payment_time, row.stop_time)
            }
            if (row.stop_time != undefined && row.payment_time == undefined) {
              return formatGap(row.create_time, row.stop_time)
            }

            return '-'
          }
        },
        {
          field: 'charge_status',
          title: '充电状态',
          visible: true,
          fuc: val => {
            let v
            switch (val) {
              case 'WAIT':
                v = '等待充电'
                break
              case 'ING':
                v = '<div style="color:#E6A23C">充电中</div>'
                break
              case 'SUCCESS':
                v = '<div style="color:#67C23A">充电完成</div>'
                break
              default:
                v = '未知状态'
                break
            }
            return v
          }
        },
        {
          field: 'stop_cause',
          title: '结束原因',
          visible: true,
          fuc: function(title, item, row) {

            if (row.charge_status != 'SUCCESS') {
              return '-'
            }

            let v
            switch (row.stop_cause) {
              case 0:
                v = '人工关闭'
                break
              case 1:
                v = '<div style="color:#E6A23C">等待充电器连接</div>'
                break
              case 2:
                v = '<div style="color:#67C23A">等待充电器启动</div>'
                break
              case 3:
                v = '<div style="color:#67C23A">快充</div>'
                break
              case 4:
                v = '<div style="color:#67C23A">浮充</div>'
                break
              case 5:
                v = '<div style="color:#67C23A">充电结束</div>'
                break
              case 6:
                v = '<div style="color:#F56C6C">充电异常，电流过载</div>'
                break
              case 7:
                v = '<div style="color:#F56C6C">充电异常，充电器未插入</div>'
                break
              case 8:
                v = '<div style="color:#F56C6C">充电异常，电流突增</div>'
                break
              case 9:
                v = '<div style="color:#F56C6C">充电异常，电压异常</div>'
                break
              case 10:
                v = '<div style="color:#67C23A">停止充电</div>'
                break
              case 11:
                v = '<div style="color:#67C23A">强制充电</div>'
                break
              case 12:
                v = '<div style="color:#F56C6C">充电异常，充电器已拔出</div>'
                break
              default:
                v = '未知状态'
                break
            }
            return v
          }
        },
        {
          field: 'status',
          title: '订单状态',
          visible: true,
          fuc: function(title, item, row) {
            let val = row.status

            let v
            switch (val) {
              case 'WAIT':
                v = '等支付'
                break
              case 'FINISH':
                v = '<div style="color:#67C23A">已支付</div>'
                break
              case 'REFUND':
                v = '<div style="color:#E6A23C">已全额退款</div>'
                break
              case 'SECTION_REFUND':
                v = '<div style="color:#E6A23C">已部分退款</div>'
                break
              case 'APPLY_REFUND':
                v = '<div style="color:#2b85e4">申请退款</div>'
                break
              case 'CLOSE':
                v = '<div style="color:#F56C6C">已关闭(' + row.close_cause + ')</div>'
                break
              default:
                v = '未知状态'
                break
            }
            return v
          }
        },
        {
          field: 'create_time',
          title: '创建时间',
          visible: true
        },
        {
          title: '操作',
          width: 80,
          option: true,
          children: [
            {
              title: '关闭订单',
              color: '#F56C6C',
              icon: 'el-icon-delete',
              fuc: row => {
                this.closeOrder(row)
              }
            },
            // {
            //   title: '申请退款',
            //   color:'#E6A23C',
            //   icon: 'el-icon-edit-outline',
            //   fuc: row => {
            //     this.applyRefund(row)
            //   }
            // },
            {
              title: '处理退款',
              color: '#2b85e4',
              icon: 'el-icon-circle-check',
              fuc: row => {
                if (row.status == 'APPLY_REFUND' || row.status == 'REFUND' || row.status == 'SECTION_REFUND') {
                  this.$router.push({ path: '/refund_order',
                    query: {
                      order_id: row.platform_trade_code,
                      create_time: row.create_time,
                      stop_time: row.stop_time,
                      payment_value: row.payment_value,
                      cash: row.cash
                    }
                  })
                } else {
                  this.$message.warning('未处在申请退款中,禁止退款操作')
                }
              }
            },
            {
              title: '申请退款',
              color: '#F56C6C',
              icon: 'el-icon-s-check',
              fuc: row => {
                if (row.status != 'FINISH' || row.charge_status == 'ING') {
                  this.$message.warning('订单未支付或处于充电中,禁止申请退款操作')
                } else {
                  this.ApplyRefund(row)
                }
              }
            }
          ]
        }
      ],
      tableParams: {
        order_id: null
      },

      formLabelWidth: '120px',
      offset: 10,
      analyseVisible: false,
      row: {}
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {
    //this.order_id = this.$route.query.order_id
    this.paginationConfig.order_id = this.$route.query.order_id
  },
  mounted() {
  },
  methods: {
    find() {
      //  this.paginationConfig.order_id = this.order_id
      if (this.findDateTime != null && this.findDateTime.length === 2) {
        this.paginationConfig.start_time = this.findDateTime[0]
        this.paginationConfig.end_time = this.findDateTime[1]
      } else {
        this.paginationConfig.start_time = ''
        this.paginationConfig.end_time = ''
      }

      this.$refs.table.refresh()
    },
    statusSelect(v) {
      this.paginationConfig.payment_status = v
    },

    applyRefund(row) {

      this.$confirm('此操作将创建退款订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let str = JSON.stringify({
          order_id: row.id,
          status: 'CLOSE'
        })

        gateway({
          func: 'set_close_payment_order',
          params: str
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error('操作失败:' + res.msg)
          }
        })
      }).catch(() => {

      })
    },
    ApplyRefund(row) {
      this.$confirm('此操作给订单号 `' + row.id + '`申请退款, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let str = JSON.stringify({
          order_id: row.id,
          cause: '后台申请退款'
        })
        gateway({
          func: 'other_apply_refund',
          params: str
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error('操作失败:' + res.msg)
          }
        })
      }).catch(() => {

      })


    },
    closeOrder(row) {

      if (row.status != 'FINISH') {
        this.$message.warning('该订单状态禁止关闭')
        return
      }

      if (row.charge_status == 'SUCCESS') {
        this.$message.warning('该充电状态禁止关闭')
        return
      }

      this.$confirm('此操作将关闭 `' + row.id + '`订单并停止充电, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let str = JSON.stringify({
          order_id: row.id,
          status: 'CLOSE'
        })

        gateway({
          func: 'set_close_payment_order',
          params: str
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error('操作失败:' + res.msg)
          }
        })
      }).catch(() => {

      })
    }


  }
}
</script>

<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}
</style>
